export class AllSettingsGrid {
    Environments: string[] = [];
    Rows: AllSettingsRow[] = [];
}

export class AllSettingsRow {
    SettingsId: number | null = null;
    Category = '';
    Name = '';
    DataType = '';
    Description = '';
    Values: SettingsRowValue[] = [];
}

export class SettingsRowValue {
    Value = '';
    SecretId = '';
    SecretValue = '';
}

export class SaveSettingsRow {
    Environments: string[] = [];
    Row: AllSettingsRow | null = null;
}
